// Counselor-owned copy of the static country reference shown on Country cards.
// Language requirements and job portals are not returned by the countries API;
// the Student AI Tools card reads the same static shape.
// Flag SVGs: see countryFlagIcons.jsx (keys match Student countryIcons).

export const COUNTRY_DETAILS = {
	USA: {
		language: [{ language: 'English (IELTS)', level: '7+' }],
		jobPortals: ['LinkedIn', 'Indeed'],
	},
	UK: {
		language: [{ language: 'English (IELTS)', level: '6.5-7+' }],
		jobPortals: ['Reed', 'TotalJobs'],
	},
	Canada: {
		language: [{ language: 'English (IELTS)', level: '6.5+' }],
		jobPortals: ['Workopolis', 'Indeed'],
	},
	Germany: {
		language: [
			{ language: 'German', level: 'B1' },
			{ language: 'English (IELTS)', level: '6.5+' },
		],
		jobPortals: ['StepStone', 'Indeed'],
	},
	Ireland: {
		language: [{ language: 'English (IELTS)', level: '6.5+' }],
		jobPortals: ['IrishJobs', 'Indeed'],
	},
	Australia: {
		language: [{ language: 'English (IELTS)', level: '6.5-7+' }],
		jobPortals: ['Seek', 'Indeed'],
	},
	'New Zealand': {
		language: [{ language: 'English (IELTS)', level: '6.5+' }],
		jobPortals: ['Seek', 'Indeed'],
	},
	'Saudi Arabia': {
		language: [
			{ language: 'Arabic', level: 'Intermediate+' },
			{ language: 'English (IELTS)', level: '6.0–6.5' },
		],
		jobPortals: ['Bayt.com', 'GulfTalent', 'NaukriGulf'],
	},
	'South Korea': {
		language: [
			{ language: 'Korean (TOPIK)', level: 'II 3–4' },
			{ language: 'English (IELTS)', level: '6.0–6.5' },
		],
		jobPortals: ['JobKorea', 'Saramin', 'LinkedIn'],
	},
	Japan: {
		language: [
			{ language: 'Japanese (JLPT)', level: 'N2–N3' },
			{ language: 'English (IELTS)', level: '6.0–6.5' },
		],
		jobPortals: ['Indeed', 'LinkedIn'],
	},
	Malaysia: {
		language: [
			{ language: 'English (IELTS)', level: '6.0–6.5' },
			{ language: 'Malay', level: 'Basic/Workplace' },
		],
		jobPortals: ['LinkedIn', 'JobStreet', 'MyFutureJobs'],
	},
	Indonesia: {
		language: [
			{ language: 'English (IELTS)', level: '6.0+' },
			{ language: 'Indonesian', level: 'Basic/Workplace' },
		],
		jobPortals: ['JobStreet', 'LinkedIn', 'KitaLulus'],
	},
	Singapore: {
		language: [{ language: 'English (IELTS)', level: '6.5–7+' }],
		jobPortals: ['MyCareersFuture', 'JobStreet', 'LinkedIn'],
	},
	Vietnam: {
		language: [
			{ language: 'English (IELTS)', level: '6.0+' },
			{ language: 'Vietnamese', level: 'Basic/Workplace' },
		],
		jobPortals: ['TopCV', 'VietnamWorks', 'ITviec'],
	},
	'United Arab Emirates': {
		language: [
			{ language: 'Arabic', level: 'Basic/Workplace' },
			{ language: 'English (IELTS)', level: '6.0–6.5' },
		],
		jobPortals: ['Bayt.com', 'NaukriGulf', 'GulfTalent'],
	},
}
